import * as React from 'react';
import ButtonNext from '../button-next/ButtonNext';
import ButtonPrevious from '../button-previous/ButtonPrevious';

import style from './FormFooter.module.css';

type Props = {
    leftButtonOnClick?: Function,
    rightButtonOnClick?: Function
}

const FormFooter = (props: Props) => {
    const previousButton = props.leftButtonOnClick ? (<ButtonPrevious onClick={props.leftButtonOnClick}>&lt; Vorige</ButtonPrevious>) : '';
    const nextButton = props.rightButtonOnClick ? (<ButtonNext onClick={props.rightButtonOnClick} arrowMode={true}>Volgende</ButtonNext>) : '';
    return (
        <React.Fragment>
            <div id={style.formFooter}>
                {previousButton}
                {nextButton}
            </div>
        </React.Fragment>
    )
}

export default FormFooter;